module.exports = __webpack_public_path__ + "img/cloudGuard.7ee7cf1.svg";